<!-- 素材审核-弹框组件 -->
<template>
  <a-modal
    v-model="visible"
    title="素材审核"
    :width="600"
    :maskClosable="false"
    :afterClose="afterClose"
  >
    <a-spin :spinning="loading">
      <a-alert message="提示：请将链接或二维码发送至管理员进行确认审核后可正常投放。" banner />
      <div class="qrcode_box">
        <div id="file_audit_link_qrcode"></div>
      </div>

      <div class="action_box">
        <a-input :value="formData.shareLink" placeholder="" readOnly class="form_item_width">
          <a-button
            slot="addonAfter"
            type="primary"
            :disabled="!formData.shareLink"
            @click="handleCopyLink"
          >
            复制链接
          </a-button>
        </a-input>
      </div>
    </a-spin>
    <template #footer>
      <a-button @click="close"> 关 闭 </a-button>
    </template>
  </a-modal>
</template>

<script>
import QRCode from 'qrcodejs2'
import * as materialApi from '@/api/material.api'
import { setClipboardData } from '@/commomFun'

/**
 * 初始化表单（提交）数据
 */
const initFormData = () => {
  return {
    planId: null,
    shareLink: ''
  }
}

export default {
  name: 'materialAuditModal',
  emits: ['afterClose'],
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      formData: initFormData()
    }
  },

  methods: {
    /**
     * 获取H5审核分享链接
     */
    async getAuditShareLink() {
      try {
        const res = await materialApi.getAuditShareLink({ planId: this.formData.planId })
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)
        this.formData.shareLink = data
        this.generateQRCode()
      } catch (err) {
        console.error('getAuditShareLink error:', err)
      }
    },

    /**
     * 生成二维码
     */
    generateQRCode() {
      this.$nextTick(() => {
        const { shareLink } = this.formData
        if (!shareLink) return
        // 清除之前的二维码
        const container = document.getElementById('file_audit_link_qrcode')
        container.innerHTML = ''
        // 生成二维码
        new QRCode(container, {
          text: shareLink,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },

    /**
     * 复制链接
     */
    async handleCopyLink() {
      try {
        let text = ''
        const { shareLink } = this.formData
        text = `素材审核链接：${shareLink}`
        await setClipboardData(text)
        this.$message.success('已复制到剪切板')
      } catch (err) {
        this.$message.error('复制失败')
      }
    },

    /**
     * 重置数据
     */
    afterClose() {
      this.loading = false
      this.formData = initFormData()
      // 清除之前的二维码
      const container = document.getElementById('file_audit_link_qrcode')
      if (container) container.innerHTML = ''
      this.$emit('afterClose')
    },

    /**
     * 打开弹窗
     */
    open(planId) {
      if (this.visible) return
      this.visible = true
      if (planId) {
        this.formData.planId = planId
        this.getAuditShareLink()
      }
    },

    /**
     * 关闭弹窗
     */
    close() {
      if (!this.visible) return
      this.visible = false
    }
  },

  mounted() {},

  beforeDestroy() {}
}
</script>

<style lang="scss" scoped>
.qrcode_box {
  width: 200px;
  height: 200px;
  background-color: #f0f2f5;
  margin: 20px auto 20px;
}

.action_box {
  /deep/ .ant-input-group-addon {
    padding: 0;
    .ant-btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border: none;
    }
  }
}
</style>
